import { render, staticRenderFns } from "./form.vue?vue&type=template&id=4d3654bd&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3654bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3654bd')) {
      api.createRecord('4d3654bd', component.options)
    } else {
      api.reload('4d3654bd', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=4d3654bd&scoped=true&", function () {
      api.rerender('4d3654bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/form.vue"
export default component.exports